module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1507-9cc4b8debe4a4c82b025f7dfd2e392da.png";